import { render, staticRenderFns } from "./FindMoreSalons.vue?vue&type=template&id=6a795566&scoped=true"
import script from "./FindMoreSalons.vue?vue&type=script&lang=js"
export * from "./FindMoreSalons.vue?vue&type=script&lang=js"
import style0 from "./FindMoreSalons.vue?vue&type=style&index=0&id=6a795566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a795566",
  null
  
)

export default component.exports